import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import styles from './styles.module.css';
import SummaryGauges from './SummaryGauges';
import SummaryHistory from './SummaryHistory';
import { PermissionsList } from '@/constants/permissionsList';
import { getSummaryPath } from '@/solaris-lens-common-lib/src/utils/turbinesPaths';
import { RootState } from '@/store';

interface SummaryTabProps {
  turbineData?: any;
  turbineStatus?: {
    powerStatus?: string;
    sentAt?: string;
    timezone?: string;
  };
}

export default function SummaryTab({
  turbineData,
  turbineStatus
}: SummaryTabProps) {
  const [turbineSummary, setTurbineSummary] = useState<any[]>([]);
  const [alarmCount, setAlarmCount] = useState<number>(0);
  const [shutdownCount, setShutdownCount] = useState<number>(0);
  const auditableElements = useSelector(
    (state: RootState) => state.auditableElements?.authorizations?.permissions
  ) as PermissionsList;

  const turbinePermissions = auditableElements?.TURBINE_DETAILS || {};
  const showAlarmCount = turbinePermissions?.ALARM_COUNT;
  const canModifyHistoryFilters = turbinePermissions?.HISTORY;

  useEffect(() => {
    if (!Object.keys(turbineData).length) return;

    setTurbineSummary(getSummaryPath(turbineData));
    setAlarmCount(turbineData.alarms?.length);
    setShutdownCount(turbineData.shutdowns?.length);
  }, [turbineData]);

  return (
    <div className={styles.container}>
      <SummaryGauges
        turbineSummary={turbineSummary}
        alarmCount={alarmCount}
        shutdownCount={shutdownCount}
        turbineStatus={turbineStatus}
        showAlarmCount={showAlarmCount}
      />
      <SummaryHistory
        canModifyFilters={canModifyHistoryFilters}
        timezone={turbineStatus?.timezone}
      />
    </div>
  );
}
